export const doctors = [
  {
    id: 1,
    name: "Dr. Aisha Rahman",
    specialization: "General & Cosmetic Dentist",
    experience: 12,
    image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=500&fit=crop",
    bio: "With over a decade of experience, Dr. Aisha combines artistry with precision to create beautiful, healthy smiles."
  },
  {
    id: 2,
    name: "Dr. Karim Hossain",
    specialization: "Orthodontist",
    experience: 9,
    image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=500&fit=crop",
    bio: "Specializing in braces and aligners, Dr. Karim transforms smiles with the latest orthodontic techniques."
  },
  {
    id: 3,
    name: "Dr. Nusrat Jahan",
    specialization: "Pediatric Dentist",
    experience: 7,
    image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=500&fit=crop",
    bio: "Dr. Nusrat creates a warm, friendly environment that makes children feel comfortable during their dental visits."
  },
  {
    id: 4,
    name: "Dr. Tariq Ahmed",
    specialization: "Implant Specialist",
    experience: 15,
    image: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&h=500&fit=crop",
    bio: "As our senior implant specialist, Dr. Tariq brings 15 years of expertise in restoring confident smiles."
  }
];

export default doctors;
